import Vue from 'vue'
import App from './App.vue'
// 関連Libインポート
import vuetify from './plugins/vuetify'
import veeValidate from "./plugins/vee-validate"
import vueLoading from "./plugins/vue-loading"
import vuejsDatepicker from "./plugins/vuejs-datepicker"
// import vueSelectSides from "./plugins/vue-select-sides"
import router from './router'
import store from './store'
import { initializeApp } from "firebase/app"
import { getAnalytics } from "firebase/analytics"
import { getFunctions } from "firebase/functions";
import scrollTo from 'vue-scrollto';

Vue.config.productionTip = false

// firebase初期設定
// TODO 環境により変更が必要なため一生残しておくTODO
const firebaseConfig = {
  apiKey: "AIzaSyDcm8WwtQKqwWPR0CnLRmWIC3WM4yasuvk",
  authDomain: "schoolaid-home-yokohamafutaba.firebaseapp.com",
  projectId: "schoolaid-home-yokohamafutaba",
  storageBucket: "schoolaid-home-yokohamafutaba.firebasestorage.app",
  messagingSenderId: "8032106383",
  appId: "1:8032106383:web:07d5c94f743f2ac90b7dfa"
};
const version = 'ver 2.1.006';
const copyright = '©Canon Electronics Technology Inc.';

const firebase = initializeApp(firebaseConfig);
const analytics = getAnalytics(firebase);
const functions = getFunctions(firebase);
functions.region = "asia-northeast1";

// validateを各種画面にて使用できるようにする
Vue.mixin(veeValidate)
Vue.mixin(vueLoading)
Vue.mixin(vuejsDatepicker)
Vue.config.devtools = true;
Vue.use(scrollTo);

new Vue({
  data: {
    isLogin: false,
    loading: false,
    siteName: "",
    userKbn: "",
    userNm: "",
    version: version,
    copyright: copyright,
  },
  vuetify,
  router,
  store,
  firebase,
  functions,
  analytics,
  render: h => h(App)
}).$mount('#app')
